import React, { useState, useEffect } from 'react'
import {
    Modal,
    Input,
    Button as CustomButton
} from '../../root/components/common'
import { makeStyles, useTheme } from '@material-ui/core'
import { useMutation, useQueryClient } from 'react-query'
import { Autocomplete } from '@material-ui/lab'
import CircularProgress from '@material-ui/core/CircularProgress'
import { useAddressApi } from '../../root/hooks/use-address-api'
import { useSelector, useDispatch } from 'react-redux'
import { updateAddress } from '../api/dashboard-api'
import { enqueueSnackbar } from '../../root/actions'

const useStyles = makeStyles(theme => ({
    buttonsContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(2)
    },
    inputMargin: {
        marginBottom: theme.spacing(2)
    }
}))

export const AddressModal = ({ open, onClose, location }) => {
    const classes = useStyles()
    const theme = useTheme()
    const { locale } = useSelector(state => state.main)
    const [address, setAddress] = useState(location?.address || '')
    const dispatch = useDispatch()
    const {
        foundAddresses,
        isLoadingAddress,
        addressSearchString,
        setAddressSearchString,
        clearSearchString
    } = useAddressApi()

    const queryClient = useQueryClient()

    const { mutate, isLoading } = useMutation(
        newAddress => updateAddress(location.id, newAddress),
        {
            onSuccess: () => {
                queryClient.invalidateQueries('mapview-locations')
                dispatch(
                    enqueueSnackbar({
                        message: locale.dashboard.addressUpdateSuccess,
                        options: {
                            variant: 'success'
                        }
                    })
                )
                onClose()
            },
            onError: () => {
                dispatch(
                    enqueueSnackbar({
                        message: locale.dashboard.addressUpdateFail,
                        options: {
                            variant: 'warning'
                        }
                    })
                )
            }
        }
    )
    const handleSave = () => {
        mutate(address)
    }

    useEffect(() => {
        if (!open) {
            setAddress('')
            setAddressSearchString('')
            clearSearchString()
        } else {
            setAddress(location?.address || '')
            setAddressSearchString(location?.address || '')
        }
    }, [location])
    return (
        <Modal open={open} onClose={onClose}>
            <div
                style={{ textAlign: 'center', marginBottom: 20, fontSize: 20 }}
            >
                {location?.name}
            </div>
            <Autocomplete
                options={foundAddresses}
                noOptionsText={locale.detachedSharing.nothingFound}
                className={classes.input}
                renderInput={params => {
                    return (
                        <Input
                            type="text"
                            {...params}
                            label={locale.locations.address}
                            variant="outlined"
                            value={addressSearchString}
                            setValue={v => {
                                setAddressSearchString(v)
                            }}
                            debounce={300}
                            autoFocus={true}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {isLoadingAddress ? (
                                            <CircularProgress size={20} />
                                        ) : null}
                                        {address &&
                                            params.InputProps.endAdornment}
                                    </>
                                )
                            }}
                        />
                    )
                }}
                onChange={(e, newValue) => {
                    setAddress(newValue)

                    if (!newValue) {
                        clearSearchString()
                    }
                }}
                value={address}
            />
            <div className={classes.buttonsContainer}>
                <CustomButton onClick={handleSave} disabled={isLoading}>
                    {isLoading ? (
                        <CircularProgress size={20} />
                    ) : (
                        locale.common.ok
                    )}
                </CustomButton>
                <CustomButton
                    reverted
                    onClick={onClose}
                    style={{ marginLeft: theme.spacing(1) }}
                >
                    {locale.common.cancel}
                </CustomButton>
            </div>
        </Modal>
    )
}
